export function isExternalLink(path?: string) {
  return path?.includes("http");
}
